<template>
  <div class="wrapper">
    <article class="left-article">
      <article-content ref="myArticle" />
    </article>
    <main class="right-main">
      <router-view @emitListen="ww" />
    </main>
  </div>
</template>

<script>
import articleContent from '@/views/entrust-proxy/proxy-task/component/article.vue'

export default {
  name: '',
  components: { articleContent },
  props: {},
  data() {
    return {}
  },
  watch: {},
  computed: {},
  methods: {
    ww(val) {
      if (val === true) {
        this.$refs.myArticle.getTaskList()
      }
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  height: calc(100vh - 80px);
  .left-article {
    width: 230px;
    border-right: 1px solid #e7e9eb;
  }
  .right-main {
    width: calc(100% - 254px);
    background: #f7f9fb;
    padding: 12px;
  }
}
</style>
